import React from "react";
import { Button } from "@mui/material";
import { primaryButtonSx } from "./styles";

function SettingsPrimaryButton({ children, sx, ...props }) {
  return (
    <Button
      variant="contained"
      disableElevation
      sx={{ ...primaryButtonSx, ...sx }}
      {...props}
    >
      {children}
    </Button>
  );
}

export default SettingsPrimaryButton;
